import http from '@/helpers/Http';

export default {
    namespaced: true,
    state: {
        items: [],
        asq: {
            address: {},
            geo: {},
            ntd: {},
            csa: {}
        },
    },
    getters: {
        items: state => state.items,
        asq: state => state.asq,
    },
    mutations: {
        setItems(state, items) {
            state.items = items;
        },
        setAsq(state, asq) {
            state.asq = asq;
        }
    },
    actions: {
        async search({ commit }, payload) {
            let response = await http.get('wideband/addresses', { params: payload});

            commit('setItems', response.data);

            return response;
        },
        async advanceSearch({ commit }, payload) {
            let response = await http.post('wideband/advanced-search-address', payload);

            commit('setItems', response.data);

            return response;
        },
        async asq({ commit }, payload) {
            let response = await http.get(`wideband/addresses/${payload.locId}`, {
                params: {
                    potsInterconnectId: payload.potsInterconnectId
                }
            });

            commit('setAsq', response.data);

            return response;
        },
    }
}